export enum IdeaScoreFieldTypes {
  impact = 'impact',
  cost = 'cost',
}
